<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
        <div class="my-5 display-1">{{email}}</div>
        <p>{{error}}</p>
        <template v-if="success">
          <p class="body-2">Uspešno ste potvrdili Vašu email adresu. Potrebno je da Vaš nalog potvrdi i administrator.</p>
          <p class="body-2">Molimo Vas pošaljite nam podatke osobe za kontakt na <a href="mailto:miljan@lanser.rs">miljan@lanser.rs</a> ili nas kontaktirajte na broj telefona +381658175678 kako bismo uzeli Vaše podatke. </p>
          <p class="body-2">Ovaj korak je neophodan kako bismo zadržali pouzdanost servisa.</p>
        </template>
        <router-link to="/login">Login</router-link>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import auth from '@/services/authService.js'
import { log } from '@/services/logService.js'

export default {
  data () {
    return {
      email: '',
      error: '',
      success: false,
      allowSignUp: false
    }
  },
  created () {
    const vm = this
    const email = vm.$route.params.email
    const code = vm.$route.params.code
    this.$router.replace('/emailVerified')
    email && auth.verify(email, code, function (result) {
      log('account ' + email + ' is verified')
      vm.email = email
      vm.success = true
      // vm.$router.push('/login')
    }, function (err) {
      log('verification failed', err)
      if (err.code === 'NotAuthorizedException') {
        // already confirmed
        vm.$router.push('/')
      } else if (err.code === 'CodeMismatchException' || err.code === 'UserNotFoundException' || err.code === 'ExpiredCodeException') {
        vm.error = 'Verifikacioni kod ne postoji, istekao je ili je već iskorišćen'
      }
    })
  }
}

</script>
